module.exports = __webpack_public_path__ + "img/barrier.e33eb34b.jpg";